import { mdiSchoolOutline } from '@mdi/js'

export default {
  title: 'Student',
  to: 'student-list',
  icon: mdiSchoolOutline,
  resource: 'StudentSchool',
  action: 'read',
}
